import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";

import {
  StyledBox,
  StyledGridBorder,
  StyledGridContainer,
} from "./style";
// import OrdersDashboard from "../../components/orders-dashboard/OrdersDashboard";
// import { orderData, statisticsTitles } from "../dashboard/constant";
import CustomHeader from "../../components/naming-header/CustomHeader";
import OrderComponent from "../../components/orders/OrderComponent";
import { CUSTOMER_ORDER_LIST, ORDER_CREATE } from "../../actions/OrderAction";
import { GET_ADDRESS_LIST } from "../../actions/AddressActions";
import {
  canCreateNewCustomerOrder,
  CREATE_ORDER_BLOCKED_MESSAGE,
  VIRTUAL_LOCKER_REQUIRED_MESSAGE,
} from "../../utils/orderCreateEligibility";
import ConfirmCreateOrder from "../../components/modals/confirm-create-order/ConfirmCreateOrder";
import { buildOrderAddressApiPayload } from "../../utils/orderAddress";

const Order = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { orderSummary, hasFetchedCustomerOrderList, recordList } = useSelector(
    (state) => state?.order ?? {}
  );
  const virtualAddress = useSelector((state) => state?.address?.virtualAddress);
  // const [statisticsData, setStatisticsData] = useState(orderData);
  const [confirmCreateOpen, setConfirmCreateOpen] = useState(false);
  const location = useLocation();
  const createOrderQueryHandled = useRef(false);

  const hasLocker =
    virtualAddress &&
    !Array.isArray(virtualAddress) &&
    Boolean(virtualAddress.locker_id);

  const canCreate = canCreateNewCustomerOrder(
    orderSummary,
    hasFetchedCustomerOrderList,
    recordList,
    virtualAddress
  );

  const disabledReason = hasLocker
    ? CREATE_ORDER_BLOCKED_MESSAGE
    : VIRTUAL_LOCKER_REQUIRED_MESSAGE;

  const createOrderAndNavigate = useCallback(
    (orderAddressValues) => {
      dispatch({
        type: ORDER_CREATE,
        payload: {
          ...buildOrderAddressApiPayload(orderAddressValues),
          onSuccess: (res) => {
            setConfirmCreateOpen(false);
            const id = res?.data?.id;
            dispatch({
              type: CUSTOMER_ORDER_LIST,
              payload: { page: 1, limit: 10 },
            });
            if (id) {
              navigate(`/dashboard/orders/${id}`);
            }
          },
        },
      });
    },
    [dispatch, navigate]
  );

  const handleCreateOrderClick = useCallback(() => {
    if (!canCreate) return;
    setConfirmCreateOpen(true);
  }, [canCreate]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("createOrder") !== "true") {
      createOrderQueryHandled.current = false;
      return;
    }
    if (!hasFetchedCustomerOrderList) return;
    if (createOrderQueryHandled.current) return;
    createOrderQueryHandled.current = true;

    if (
      !canCreateNewCustomerOrder(
        orderSummary,
        hasFetchedCustomerOrderList,
        recordList,
        virtualAddress
      )
    ) {
      toast.error(disabledReason);
      navigate("/dashboard/orders", { replace: true });
      return;
    }

    setConfirmCreateOpen(true);
    navigate("/dashboard/orders", { replace: true });
  }, [
    location.search,
    hasFetchedCustomerOrderList,
    orderSummary,
    recordList,
    virtualAddress,
    disabledReason,
    navigate,
  ]);

  useEffect(() => {
    dispatch({ type: GET_ADDRESS_LIST });
  }, [dispatch]);

  // useEffect(() => {
  //   const statisticsData = orderData.map((item) => {
  //     switch (item.title) {
  //       case statisticsTitles.totalRequestsMade:
  //         return { ...item, value: orderSummary?.total_request_made || 0 };
  //       case statisticsTitles.ordersCompleted:
  //         return { ...item, value: orderSummary?.order_completed || 0 };
  //       case statisticsTitles.ordersInProgress:
  //         return { ...item, value: orderSummary?.order_in_progress || 0 };
  //       case statisticsTitles.awaitingPaymentApproval:
  //         return { ...item, value: orderSummary?.await_payment_approval || 0 };
  //       case statisticsTitles.pendingConfirmationFromShopper:
  //         return { ...item, value: orderSummary?.pending_confirmation_from_shopper || 0 };
  //       case statisticsTitles.nextEstimatedDelivery:
  //         return { ...item, value: orderSummary?.next_estimated_delivery || 0 };
  //       default:
  //         return item;
  //     }
  //   });
  //   setStatisticsData(statisticsData);
  // }, [orderSummary]);

  return (
    <>
      <StyledBox>
        <CustomHeader
          title="Order"
          label="Create a Order"
          onClick={handleCreateOrderClick}
          disabled={!canCreate}
          disabledReason={disabledReason}
        />
        <ConfirmCreateOrder
          open={confirmCreateOpen}
          onClose={() => setConfirmCreateOpen(false)}
          onConfirm={createOrderAndNavigate}
        />
        {/* <OrdersDashboard title="ORDERS" idDataList={statisticsData || []} /> */}
        <StyledGridContainer container>
          <StyledGridBorder size={{ md: 12, xs: 12 }}>
            <OrderComponent />
          </StyledGridBorder>
        </StyledGridContainer>
      </StyledBox>
    </>
  );
};

export default Order;
